export const dataDefault = [
    {
        "name": "1000&lt;Conference Area<br/>1000&lt;会议厅面积",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 0
    },
    {
        "name": "Ballroom A<br/>多功能宴会厅A",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 1
    },
    {
        "name": "Ballroom B<br/>多功能宴会厅B",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 2
    },
    {
        "name": "500<=Conference Area<1000<br/>500<=会议厅面积<1000",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 3
    },
    {
        "name": "Conference A<br/>大会议室A",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 4
    },
    {
        "name": "Conference B<br/>大会议室B",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 5
    },
    {
        "name": "Conference C<br/>大会议室C",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 6
    },
    {
        "name": "Conference D<br/>大会议室D",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 7
    },
    {
        "name": "Conference E<br/>大会议室E",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 8
    },
    {
        "name": "Conference F<br/>大会议室F",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 9
    },
    {
        "name": "Conference G<br/>大会议室G",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 10
    },
    {
        "name": "Conference H<br/>大会议室H",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 11
    },
    {
        "name": "Conference I<br/>大会议室I",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 12
    },
    {
        "name": "Conference J<br/>大会议室J",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 13
    },
    {
        "name": "200<=Conference Area<500<br/>200<=会议厅面积<500",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 14
    },
    {
        "name": "Conference A<br/>中会议室A",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 15
    },
    {
        "name": "Conference B<br/>中会议室B",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 16
    },
    {
        "name": "Conference C<br/>中会议室C",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 17
    },
    {
        "name": "Conference D<br/>中会议室D",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 18
    },
    {
        "name": "Conference E<br/>中会议室E",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 19
    },
    {
        "name": "Conference F<br/>中会议室F",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 20
    },
    {
        "name": "Conference G<br/>中会议室G",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 21
    },
    {
        "name": "Conference H<br/>中会议室H",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 22
    },
    {
        "name": "Conference I<br/>中会议室I",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 23
    },
    {
        "name": "Conference J<br/>中会议室J",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 24
    },
    {
        "name": "Conference Area<200<br/>会议厅面积<200",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 25
    },
    {
        "name": "Conference A<br/>小会议室A",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 26
    },
    {
        "name": "Conference B<br/>小会议室B",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 27
    },
    {
        "name": "Conference C<br/>小会议室C",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 28
    },
    {
        "name": "Conference D<br/>小会议室D",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 29
    },
    {
        "name": "Conference E<br/>小会议室E",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 30
    },
    {
        "name": "Conference F<br/>小会议室F",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 31
    },
    {
        "name": "Conference G<br/>小会议室G",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 32
    },
    {
        "name": "Conference H<br/>小会议室H",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 33
    },
    {
        "name": "Conference I<br/>小会议室I",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 34
    },
    {
        "name": "Conference J<br/>小会议室J",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 35
    },
    {
        "name": "Conference K<br/>小会议室K",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 36
    },
    {
        "name": "Conference L<br/>小会议室L",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 37
    },
    {
        "name": "Conference M<br/>小会议室M",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 38
    },
    {
        "name": "Conference N<br/>小会议室N",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 39
    },
    {
        "name": "Conference O<br/>小会议室O",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 40
    },
    {
        "name": "Conference P<br/>小会议室P",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 41
    },
    {
        "name": "Conference Q<br/>小会议室Q",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 42
    },
    {
        "name": "Conference R<br/>小会议室R",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 43
    },
    {
        "name": "Conference S<br/>小会议室S",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 44
    },
    {
        "name": "Conference T<br/>小会议室T",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 45
    },
    {
        "name": "Total<br/>总计",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 46
    }, {
        "name": "",
        "meet": 0,
        "space": 0,
        "no": 0,
        "sold": 0,
        "occ": 0,
        "total": 0,
        "sc": 0,
        "rev": 0,
        "sort": 47
    }
]



function twoPoints(arr, num) {
    if (arr.length <= 1) return arr[0] === num;

    let isTrue = false;
    const len = Math.floor(arr.length / 2);
    if (arr[len] === num) return true;

    if (arr[len] > num) {
        isTrue = twoPoints(arr.slice(0, len - 1), num);
    }

    if (arr[len] < num) {
        isTrue = twoPoints(arr.slice(len, arr.length - 1), num);
    }

    return isTrue
}


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-2/data.js